import React from 'react';

import { Flex } from '@chakra-ui/react';

import { Divider } from 'uiToolkitV1/Divider';
import { Radio } from 'uiToolkitV1/Radio/Radio';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const RadioSelect = ({
  isDisabled = false,
  name,
  onChange,
  options = [],
  selectedIndex = 0,
  containerProps = {},
  optionsProps = {},
  isDividerBetweenOptions = false,
  isVertical = false,
  ...props
}) => {
  const onChangeHandler = (index) => {
    onChange(index);
  };

  const isLastOption = (index) => index === options.length - 1;
  const margin = isVertical ? { mb: 3 } : { mr: 3 };

  return (
    <Flex mt="14px" direction={isVertical ? 'column' : 'row'} width={isVertical ? '100%' : 'auto'} {...containerProps}>
      {options.map(({ isDisabled, name }, index) => (
        <>
          <Flex {...margin} minW="140px" {...optionsProps}>
            <Radio
              isChecked={selectedIndex === index}
              name=""
              onChange={() => onChangeHandler(index)}
              isDisabled={isDisabled}
            >
              <TextBodyMedium pr={4}>{name}</TextBodyMedium>
            </Radio>
          </Flex>
          {isDividerBetweenOptions && isVertical && !isLastOption(index) && <Divider borderColor="#EBEFF3" my="10px" />}
        </>
      ))}
    </Flex>
  );
};

export { RadioSelect };
